<script setup lang="ts">
  import { computed } from 'vue';
  import { useShared } from '@othercommerce/foundation';

  const props = defineProps({
    value: { type: String, required: false },
    time: { type: Boolean, required: false, default: false },
  });

  const shared = useShared();

  const normalized = computed(() => {
    return props.value ? new Date(props.value) : null;
  });

  const formatter = computed(() => {
    return new Intl.DateTimeFormat(shared.value.appLocale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: props.time ? '2-digit' : undefined,
      minute: props.time ? '2-digit' : undefined,
      timeZone: shared.value.appTimezone,
    });
  });
</script>
<template>
  <time v-if="normalized instanceof Date && !isNaN(normalized.getTime())" :datetime="value">
    {{ formatter.format(normalized) }}
  </time>
</template>
